import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { ADMIN_CONTACTS_LOCAL_API_REQUESTS } from './utils/constants';

// Cross-company recipient search, for Lixani system admins. No
// activeEmployerInfo: the route is deliberately not business-scoped, so signing
// employer headers it never reads would only be misleading.
export const getAdminContacts = async (query) => {
  const signedRequest = await createSignedGetRequest({
    apiPath: `admin/contacts/search?q=${encodeURIComponent(query)}`,
    isLocalApiRequest: ADMIN_CONTACTS_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);

  return response.data;
};
